import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { selectCatalogingOnSiteEnabled } from '../../catalog/selectors/CatalogSelectors';
import { clearSpaceContentCountsAction, contentCountsRequest } from '../../app/actions/spaces/ContentCountsActions';
import { requestSpaceContents } from '../../app/actions/spaces/RequestSpaceContentsActions';
import { selectContentCounts, selectContentCountsUpToDate } from '../../app/selectors/ContentCountsSelector';
import { selectMixedContentFilterClauses, selectSearchText } from '../../app/selectors/ContentFilterSelectors';
import { CompositeSessionInfoSelectors } from '../../app/selectors/SessionInfoSelectors';
import { siteUrlsSelector } from '../../app/selectors/SiteUrlsSelectors';
import { AppState } from '../../app/state/AppState';
import { MapDispatchToProps, MapStateToProps } from '../../app/utils/ConnectUtils';
import { SearchSpace, SearchSpaceDispatchProps, SearchSpaceOwnProps, SearchSpaceStateProps } from './SearchSpace';

const mapStateToProps: MapStateToProps<SearchSpaceStateProps> = (state: AppState) => ({
  urls: siteUrlsSelector(state),
  searchTerm: selectSearchText(state),
  contentFilters: selectMixedContentFilterClauses(state),
  contentCounts: selectContentCounts<'search'>(state, 'search'),
  contentCountsUptoDate: selectContentCountsUpToDate(state),
  catalogingOnSiteEnabled: selectCatalogingOnSiteEnabled(state),
  areUsersVisible: !CompositeSessionInfoSelectors.isLimitedUserVisibilityEnforced(state)
});

const mapDispatchToProps: MapDispatchToProps<SearchSpaceDispatchProps> =
  (dispatch) => bindActionCreators({
    requestSpaceContents: requestSpaceContents,
    fetchUpdatedContentCounts: contentCountsRequest,
    clearContentCounts: clearSpaceContentCountsAction
  },
  dispatch);

export const ConnectedSearchSpace: React.ComponentClass<SearchSpaceOwnProps>
  = connect(mapStateToProps, mapDispatchToProps)(SearchSpace);
